import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import WeekView_2_0 from './WeekView_2.0';
// import WeekView from './WeekView';

const TherapyPlanningInfo_2_0 = () => {
  const selectedPatient = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const getMultipleMdsAssessment = useSelector(
    (state: any) => state.getMultipleMDSAssessment?.response?.data
  );

  const isMdsPresent =
    getMultipleMdsAssessment?.filter((res: any) => res?.status === 'OPENED')?.[0]?.mdsAssessments
      ?.length ?? 0;

  const navigate = useNavigate();
  useEffect(() => {
    if (
      selectedPatient && (selectedPatient?.isNonTherapy)) {
      navigate('/scheduling/therapy-planning/details');
    } else {
      navigate('/scheduling/therapy-planning/details/info');
    }
  }, [selectedPatient]);

  return <WeekView_2_0 />;
};

export default TherapyPlanningInfo_2_0;
